import { useState } from "react"

import { Select } from "../shared-components/select"
import "./shape-variants.css"

// Each slot's look, in bottom→top plate order — red, checker, green.
const SWATCH_CLASSES = ["sv-swatch--red", "sv-swatch--checker", "sv-swatch--green"]

const EFFECTS: readonly { key: string; label: string }[] = [
  { key: "1", label: "1 — Glass" },
  { key: "2", label: "2 — Chrome" },
  { key: "3", label: "3 — Neon" },
  { key: "4", label: "4 — Enamel" },
  { key: "5", label: "5 — Velvet" },
  { key: "6", label: "6 — Galaxy" },
]

interface BallVariant {
  className: string
  id: string
  logic: string
  name: string
}

const VARIANTS: readonly BallVariant[] = [
  {
    className: "sv-shape--circle",
    id: "circle",
    logic: "filled circle",
    name: "Circle",
  },
  {
    className: "sv-shape--donut",
    id: "donut",
    logic: "circle with hole",
    name: "Circle • hole",
  },
  {
    className: "sv-shape--star",
    id: "star",
    logic: "5-point star",
    name: "Star",
  },
  {
    className: "sv-shape--star12",
    id: "star12",
    logic: "12-edge star",
    name: "Star 12",
  },
  {
    className: "sv-shape--square",
    id: "square",
    logic: "square",
    name: "Square",
  },
  {
    className: "sv-shape--square-donut",
    id: "square-donut",
    logic: "square with hole",
    name: "Square • hole",
  },
  {
    className: "sv-shape--square-circle",
    id: "square-circle",
    logic: "square with circle within",
    name: "Square ◯",
  },
  {
    className: "sv-shape--circle-square",
    id: "circle-square",
    logic: "circle with square within (vice versa)",
    name: "Circle □",
  },
  {
    className: "sv-shape--triangle",
    id: "triangle",
    logic: "triangle",
    name: "Triangle",
  },
  {
    className: "sv-shape--hexagon",
    id: "hexagon",
    logic: "hexagon",
    name: "Hexagon",
  },
  {
    className: "sv-shape--diamond",
    id: "diamond",
    logic: "diamond",
    name: "Diamond",
  },
]

export function BallVariants() {
	const [effect, setEffect] = useState<string>("2")

  return (
    <section aria-label="Shape variants in 5-high plate" className="sv">
      <h2 className="text-xl font-bold">
        Shape variants — {VARIANTS.length} shapes × 5-high plate (3 filled)
      </h2>
      <p className="">
        Each plate is 5 slots high (same deep-dish as sortaballs), 3 shapes
        stacked at bottom — middle ball is checkers. Global 3D effect below
        applies to every figure.
      </p>

      <div className="max-w-80">
        <Select
          initialValue={effect}
          label="Global 3D effect"
          onChange={setEffect}
          options={[...EFFECTS]}
        />
      </div>

      <div className="sv-grid">
        {VARIANTS.map(({ className, id, logic, name })=> (
          <figure className="sv-card" key={id}>
            <div aria-hidden="true" className="sv-plate">
              {[0, 1, 2].map(slot=> {
                const isChecker = slot === 1
                return (
                  <span
                    className={`
                      sv-shape
                      ${className}
                      sv-effect--${effect}
                      ${isChecker ? `sv-shape--checker` : ""}
                      ${SWATCH_CLASSES[slot] ?? ""}
                    `}
                    key={slot}
                  />
                )
              })}
            </div>
            <figcaption className="sv-caption">
              <strong>{name}</strong>
              <code>{logic}</code>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  )
}
